import React from "react";
import { useLocation } from "react-router-dom";

export default function DashboardNavBar() {
  const location = useLocation();
  const isAfrica = location.pathname.includes("dashboard");
  return (
    <div>
      <h1
        className="text-center"
        style={{ color: "white", fontFamily: "timesnewromans" }}
      >
        {"SUB-SAHARAN AFRICA ECONOMIC OUTLOOK"}
      </h1>
    </div>
  );
}
